const log1StartDate = new Date()
log1StartDate.setDate(log1StartDate.getDate() - 60)
const log2StartDate = new Date()
log2StartDate.setDate(log2StartDate.getDate() - 50)
const goal1StartDate = new Date()
goal1StartDate.setDate(goal1StartDate.getDate() - 60)
const goal2StartDate = new Date()
goal2StartDate.setDate(goal2StartDate.getDate() - 50)
export const demoUserGoals = [
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a1",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"quantity": 200,
		"unit": "kgs",
		"plan": "test",
		"timeFrame": 90,
		"start": +goal1StartDate,
		"notes": "This should end for the same day of the competition."
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a2",
		"user": "demo@debloat.us",
		"movement": "Run",
		"quantity": 80000,
		"unit": "mts",
		"plan": "accu",
		"timeFrame": 60,
		"start": +goal2StartDate,
		"notes": "Medic advice."
	},

]

export const demoUserLogs = [
	// run
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a3",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a4",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a5",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 4000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 3),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a6",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 10000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a7",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a8",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 3),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1a9",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 4000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1aa",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 10000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1ab",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1ac",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 3),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1ad",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 4000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1ae",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 10000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1af",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b0",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 3),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b1",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 4000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b2",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 10000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b3",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b4",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 3),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b5",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 4000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b6",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 10000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b7",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b8",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 3),
		"notes": "ten percent!"
	},

	{
		"_id": "5e8e2b3b9b0b8e0017b6d1b9",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 4000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1ba",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 10000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 1),
		"notes": "ten percent!"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1bb",
		"user": "demo@debloat.us",
		"movement": "Run",
		"reps": 1,
		"sets": 1,
		"strain": 8000,
		"unit": "mts",
		"duration": 60,
		"date": +log2StartDate.setDate(log2StartDate.getDate() + 2),
		"notes": "ten percent!"
	},
	// deadlift
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1bc",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 150,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1bd",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 140,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1be",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 4,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1bf",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 5,
		"sets": 3,
		"strain": 100,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c0",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 170,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c1",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 150,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c2",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 4,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c3",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 5,
		"sets": 3,
		"strain": 100,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c4",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 180,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c5",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 160,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c6",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 4,
		"sets": 3,
		"strain": 140,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c7",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 5,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b8e0017b6d1c8",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 190,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b0b9e0017b6d1c9",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 160,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9b1b8e0017b6d1c1",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 140,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b3b9c0b8e0017b6d1c2",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2b4b9b0b8e0017b6d1c3",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 1,
		"sets": 3,
		"strain": 195,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e2c3b9b0b8e0017b6d1c4",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 160,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "5e8e3b3b9b0b8e0017b6d1c5",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 140,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "5e9e2b3b9b0b8e0017b6d1c6",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "6e8e2b3b9b0b8e0017b6d1c7",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 195,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "7e8e2b3b9b0b8e0017b6d1c8",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 170,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "8e8e2b3b9b0b8e0017b6d1c9",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 150,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "9e8e2b3b9b0b8e0017b6d1ca",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "10e8e2b3b9b0b8e0017b6d1cb",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 1,
		"sets": 3,
		"strain": 203,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "11e8e2b3b9b0b8e0017b6d1cc",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "12e8e2b3b9b0b8e0017b6d1cd",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "13e8e2b3b9b0b8e0017b6d1ce",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 110,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "14e8e2b3b9b0b8e0017b6d1cf",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 150,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "15e8e2b3b9b0b8e0017b6d1d0",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "16e8e2b3b9b0b8e0017b6d1d1",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 1,
		"sets": 3,
		"strain": 203,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "17e8e2b3b9b0b8e0017b6d1d2",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "18e8e2b3b9b0b8e0017b6d1d3",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "19e8e2b3b9b0b8e0017b6d1d4",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 110,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "20e8e2b3b9b0b8e0017b6d1d5",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 1,
		"sets": 3,
		"strain": 203,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "21e8e2b3b9b0b8e0017b6d1d6",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "22e8e2b3b9b0b8e0017b6d1d7",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "23e8e2b3b9b0b8e0017b6d1d8",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 110,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "24e8e2b3b9b0b8e0017b6d1d9",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 2,
		"sets": 3,
		"strain": 130,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 2),
		"notes": "building volume"
	},
	{
		"_id": "25e8e2b3b9b0b8e0017b6d1da",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 3,
		"sets": 3,
		"strain": 120,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
	{
		"_id": "26e8e2b3b9b0b8e0017b6d1db",
		"user": "demo@debloat.us",
		"movement": "Deadlift",
		"reps": 6,
		"sets": 3,
		"strain": 110,
		"unit": "kgs",
		"duration": 15,
		"date": +log1StartDate.setDate(log1StartDate.getDate() + 1),
		"notes": "building volume"
	},
]
